import React, { useEffect, useState } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import { PlusIcon } from "~/assets/svg/MathIcon";
import { RoundMinusIcon } from "~/assets/svg/InterfaceIcon";
import Input from "~/common/components/Input";
import { API_STATE } from "~/common/constants/state";
import useRequest from "~/common/hooks/useRequest";
import AlertTemplate from "~/common/components/AlertPortal/AlertTemplate";
import { useTranslation } from "react-i18next";
import { makeRandomPassword } from "~/utils/password";
import ExcelLoader from "~/common/components/Excel";

const InviteInputGroup = ({ index, remove, errors, inviteForm }) => {
	const { t } = useTranslation();
	return (
		<div className="f__group-row">
			<div className="f__group team-invite-name">
				<div
					className={`f__control  ${errors.inviteFormField?.[index]?.name ? "has-error" : ""
						}`}
				>
					<Input
						{...inviteForm}
						name={`inviteFormField.${index}.name`}
						required
						placeholder={t("pages.myPage.admin.TeamPage.InvitationModal.name")}
					/>
					{errors.inviteFormField?.[index] && (
						<p className="f__feedback">
							{errors.inviteFormField[index]?.name?.message}
						</p>
					)}
				</div>
			</div>
			<div className="f__group team-invite-mail">
				<div
					className={`f__control  ${errors.inviteFormField?.[index]?.id ? "has-error" : ""
						}`}
				>
					<Input
						{...inviteForm}
						name={`inviteFormField.${index}.id`}
						required
						placeholder={t("pages.myPage.admin.TeamPage.InvitationModal.email")}
						type={"email"}
						validation={{
							pattern: {
								value: /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i,
								message: t(
									"pages.myPage.admin.TeamPage.InvitationModal.emailMassage"
								),
							},
						}}
					/>
					{errors.inviteFormField?.[index] && (
						<p className="f__feedback">{errors.inviteFormField[index]?.id?.message}</p>
					)}
				</div>
			</div>
			<div className="f__group team-invite-password">
				<div
					className={`f__control  ${errors.inviteFormField?.[index]?.pw ? "has-error" : ""
						}`}
				>
					<Input
						{...inviteForm}
						name={`inviteFormField.${index}.pw`}
						readonly
						placeholder={t("pages.myPage.admin.TeamPage.InvitationModal.password")}
						// type={"password"}
						validation={{
							minLength: {
								value: 8,
								message: "최소 8자 이상 입력해주세요.",
							},
						}}
					/>
					{errors.inviteFormField?.[index] && (
						<p className="f__feedback">{errors.inviteFormField[index]?.pw?.message}</p>
					)}
				</div>
			</div>
			<button type="button" className="btn-round-delete" onClick={() => remove(index)}>
				<RoundMinusIcon />
			</button>
		</div>
	);
};

const InvitationModal = ({
	setTeamInviteRequestModal,
	setInviteModal,
	invitedTeamMemberRequest,
	setInviteResponseData,
	excelData, setExcelData, error
}) => {

	const handleUpload = (data) => {
		let englishArray = data.map(item => ({
			// 다음 항목들이 모두 존재하는지 발리데이션,joinDate,workStartDay 포멧 검사 연도 통일 
			name: item["이름"],
			email: item["이메일"],
			department: item["부서"],
			position: item["지급"], // YYYY-MM-DD 포맷만 추출

		}));

		englishArray = englishArray.filter(ele => ele.name !== '예시) 홍길동')
		setExcelData(englishArray)
	}

	const inviteModalHeader = (
		<div //className="team-add-modal-header-wrapper"
		>
			<div className="team-add-modal-header-wrapper">
				<h3>팀원 정보입력</h3>
				<ExcelLoader
					downLoadFormat={[
						{
							이름: "예시) 홍길동",
							이메일: "hong@gitbal.com",
							부서: "VC",
							지급: '대표'
						}
					]}

					name={`팀원초대_기본양식`}
					onAction={handleUpload}
				/>
			</div>
			<div className="team-add-modal-sub-wrapper">
				<h4>초대할 팀원의 이름, 이메일을 입력해 주세요.</h4>
				<p>비밀번호는 자동으로 부여됩니다. 메일 재전송이 필요할 경우 팀원 목록 우측에 있는 버튼을 클릭해 주세요.</p>
			</div>
		</div>
	)

	const { t } = useTranslation();
	const inviteForm = useForm();
	const {
		setError,
		control,
		handleSubmit,
		formState: { errors },
	} = inviteForm;
	const inviteRequest = useRequest("post", "/vc/admin/invite");

	const [emptyInviteAlert, setEmptyInviteAlert] = useState(false);

	const { fields, append, remove } = useFieldArray({
		control,
		name: "inviteFormField",
		keyName: "key",
	});

	const request = (data) => {
		if (data.inviteFormField.length === 0) {
			setEmptyInviteAlert(true);
			return null;
		}
		let duplicatedList = [];
		data.inviteFormField.forEach((d, index) => {
			const length = data.inviteFormField.filter(({ id }) => id === d.id).length;
			if (length > 1) {
				duplicatedList.push(index);
			}
		});
		if (duplicatedList.length > 0) {
			duplicatedList.forEach((i) => {
				setError(`inviteFormField.${i}.id`, {
					type: "duplicated",
					message: t("pages.myPage.admin.TeamPage.InvitationModal.main-message"),
				});
			});
		} else {
			inviteRequest.call({ inviteList: data.inviteFormField });
		}
	};

	useEffect(() => {
		switch (inviteRequest.state) {
			case API_STATE.done:
				const responseData = inviteRequest.response.data;
				setInviteModal(false);
				setTeamInviteRequestModal(true);
				setInviteResponseData(responseData);
				invitedTeamMemberRequest.call();
				break;
			case API_STATE.error:
				switch (inviteRequest.error.statusCode) {
					case 401:
						alert(t("pages.myPage.admin.TeamPage.InvitationModal.error1"));
						break;
					case 409:
						alert(t("pages.myPage.admin.TeamPage.InvitationModal.error2"));
						break;
					case 500:
					default:
						console.log("error", inviteRequest.error);
						alert(t("common.commonWord.alert.wait2"));
						break;
				}
				break;
			default:
				break;
		}
	}, [inviteRequest.state, inviteRequest.response, inviteRequest.error]);

	useEffect(() => {
		if (excelData.length > 0) {
			append(excelData
				.map(ele => ({ ...ele, id: ele.email, pw: makeRandomPassword() })).map(({ email, ...rest }) => rest));
		}
	}, [excelData])


	return (
		<>
			{inviteModalHeader}
			<div className="modal-content invite-form">
				<button
					className="dashed-btn plus-btn"
					color="primary"
					onClick={() => append({ name: "", id: "", pw: makeRandomPassword() })}
				>
					<PlusIcon />
					{t("pages.myPage.admin.TeamPage.InvitationModal.plus-btn")}
				</button>
				{fields.map((item, idx) => (
					<InviteInputGroup
						key={item.key}
						index={idx}
						control={control}
						remove={remove}
						inviteForm={inviteForm}
						errors={errors}
					/>
				))}
			</div>
			<div className="modal-footer">
				<button className="btn__solid" color="gray" onClick={() => setInviteModal(false)}>
					{t("common.commonWord.button.cancel")}
				</button>
				<button className="btn__solid" color="primary" onClick={handleSubmit(request)}>
					{t("common.commonWord.button.invite")}
				</button>
			</div>

			<AlertTemplate
				alertModalState={emptyInviteAlert}
				setAlertModalToggle={setEmptyInviteAlert}
				width={420}
				alertType="warning"
			>
				<p className="alert-content">
					<div className="modal-text">
						{t("pages.myPage.admin.TeamPage.InvitationModal.modal-text")}
					</div>
				</p>
				<div className="alert-footer">
					<button
						className="btn__solid"
						color="primary"
						onClick={() => setEmptyInviteAlert(false)}
					>
						{t("common.commonWord.button.check")}
					</button>
				</div>
			</AlertTemplate>
		</>
	);
};

export default InvitationModal;
